// removed by extract-text-webpack-plugin
module.exports = {"basicContainer":"_139x03d-JJR5zG0BW8zK11"};


//////////////////
// WEBPACK FOOTER
// ./app/client/bundles/EventSubmission/containers/SubmissionSteps/BasicsPage.scss
// module id = 819
// module chunks = 0